// React
import { FC } from 'react'

// Custom
import { Button, Line, Icon } from './styled'

type Props = {
  active: boolean
  onClick: () => void
}

const Hamburger: FC<Props> = ({ active, onClick }: Props) => {
  return (
    <Button onClick={onClick} data-testid="button">
      <Line />
      <Icon active={active} />
    </Button>
  )
}

export default Hamburger
